<template>
  <div class="cx-category-api local-item"
        v-if="apiData">
    
    <div  v-if="getLogoUrl(api.pictureUrl) !== null"
          v-b-tooltip.html
          :title="getLineHeaderTooltip()"
          class="local-image-place clickable">
      <img  :src="getLogoUrl(api.pictureUrl)"
            class="local-image" />
    </div>
    <div  v-else
          class="local-text-place"
          v-b-tooltip.html
          :title="getLineHeaderTooltip()">
      <span>{{ getTitle() }}</span>
    </div>
    
    <div  class="local-text local-text-place"
          :class="{ 'local-last-value': index === 3 }"
          v-b-tooltip.html
          :title="getTooltip(no, index)"
          v-for="(no, index) in [ 3, 2, 1, 0 ]" :key="index">
      {{ getValueText(no) }}
      <CxIconValueIndicator v-if="getValue(no) != null && getValue(no + 1) != null"
                            :actual="getValue(no)"
                            :last="getValue(no + 1)"
                            :threshold="threshold" />
    </div>

    <div class="local-end local-text-place">
      <b-icon v-if="isAccomplished(0)"
              :color="threshold[2].Color" 
              icon="check"
              scale="1.5" />
      <b-icon v-else-if="isAccomplished(0) === false"
              :color="threshold[0].Color"
              class="b-icon-animation-fade" 
              icon="exclamation" 
              scale="1.5" />
      
      <b-icon v-if="!isNonExploration(api) && isAccomplished(0) !== undefined"
              aria-hidden="true"
              class="cx-clickable-icon"
              icon="search"
              @click="togglePopup">
      </b-icon>

      <template v-if="apiData.type == 'EXPLORATION'">
        <ExplorationSurveyPopup
          v-if="showPopup"
          :surveyData="apiData"
          :headLine="clientInfo.name"
          :clientLocationId="clientInfo.clientLocationId"
          @close="showPopup = false"
          :style="{ top: 160 + 'px', left:  300 + 'px', 'text-align': 'left' }"
          class="popup survey-popup"
          :ref="`popup_Survey_${apiData.ExternalSurveyId}`"
        />
      </template>
      <template v-else>
        <!-- Google Popup  -->
        <template v-if="apiData.ApiName == 'Google'">
          <ExplorationGooglePopup
            v-if="showPopup"
            :googleData="apiData"
            :headLine="clientInfo.name"
            :address="dealerData.AllTexts"
            :googlePlacesID="getCustomPropValue('googleplacesid')"
            :style="{ top: 160 + 'px', left: 470 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            @close="showPopup = false"
            @open-competitor="openCompetitor(...arguments)"
            class="popup google-popup"
            ref="popup_Google"
          />

          <ExplorationGooglePopup
            v-for="(compId, index) in Competitors"
            :key="`Google_${compId}`"
            :isCompetitor="true"
            :competitorId="compId"
            @close="Competitors.splice(index, 1)"
            class="popup google-popup"
            :style="{ top: calcTop(160, index) + 'px', left: calcLeft(470, index) + 'px', width: 800 + 'px', 'text-align': 'left' }"
          />
        </template>

        <!-- Seobility Popup -->
        <template v-if="apiData.ApiName == 'Seobility'">
          <ExplorationSeobilityPopup
            v-if="showPopup"
            :style="{ top: 160 + 'px', left: 470 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            :seobilityData="apiData"
            :seobilityURL="getCustomPropValue('url: dealer website')"
            headerLine="seobility Retailer"
            :clientLocationId="clientInfo.clientLocationId"
            :headLine="clientInfo.name"
            @close="showPopup = false"
            @open-competitor="openCompetitor(...arguments)"
            class="popup seobility-popup"
            ref="popup_Seobility"
          />

          <ExplorationSeobilityPopup
            v-for="(compId, index) in Competitors"
            :key="`Seo_${compId}`"
            :isCompetitor="true"
            :competitorId="compId"
            :clientLocationId="clientInfo.clientLocationId"
            :style="{ top: calcTop(160, index) + 'px', left: calcLeft(470, index) + 'px', width: 800 + 'px', 'text-align': 'left' }"
            @close="Competitors.splice(index, 1)"
            class="popup seobility-popup"
          />
        </template>

        <!-- Seobility2 Popup -->
        <template v-if="apiData.ApiName == 'Seobility2'">
          <ExplorationSeobilityPopup
            v-if="showPopup"
            :seobilityData="apiData"
            :seobilityURL="getCustomPropValue('url: corporate website')"
            :style="{ top: 160 + 'px', left: 470 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            :clientLocationId="clientInfo.clientLocationId"
            headerLine="seobility Corporate"
            :headLine="clientInfo.name"
            @close="showPopup = false"
            class="popup seobility-popup"
            ref="popup_Seobility2"
          />
        </template>

        <template v-if="apiData.ApiName == 'Auto Scout 24'">
          <ExplorationAutoscoutPopup 
            v-if="showPopup"
            :autoscoutData="apiData"
            :autoscoutURL="getCustomPropValue('url: autoscout24')"
            :style="{ top: 160 + 'px', left: 470 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            :headLine="clientInfo.name"
            @close="showPopup = false"
            @open-competitor="openCompetitor(...arguments)"
            class="popup autoscout-popup"
            ref="popup_Autoscout"
          />
          <ExplorationAutoscoutPopup
            v-for="(compId, index) in Competitors"
            :key="`Autoscout_${compId}`"
            :isCompetitor="true"
            :competitorId="compId"
            @close="Competitors.splice(index, 1)"
            :style="{ top: calcTop(160, index) + 'px', left: calcLeft(470, index) + 'px', width: 800 + 'px', 'text-align': 'left'  }"
            class="popup autoscout-popup"
          />
        </template>

        <!-- Mobile Popup -->
        <template v-if="apiData.ApiName == 'Mobile.de'">
          <ExplorationMobilePopup
            v-if="showPopup"
            :mobileData="apiData"
            :mobileURL="getCustomPropValue('url: mobile.de')"
            :headLine="clientInfo.name"
            @close="showPopup = false"
            @open-competitor="openCompetitor(...arguments)"
            class="popup mobile-popup"
            :style="{ top: 190 + 'px', left:  560 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            ref="popup_Mobile"
          />

          <ExplorationMobilePopup
            v-for="(compId, index) in Competitors"
            :key="`Mobile_${compId}`"
            :isCompetitor="true"
            :competitorId="compId"
            @close="Competitors.splice(index, 1)"
            :style="{ top: calcTop(190, index) + 'px', left: calcLeft(560, index) + 'px', width: 800 + 'px', 'text-align': 'left' }"
            class="popup mobile-popup"
          />
        </template>

        <!-- Autocasion Popup  -->
        <template v-if="apiData.ApiName == 'Autocasion'">
          <ExplorationAutocasionPopup
            v-if="showPopup"
            :autocasionData="apiData"
            :headLine="clientInfo.name"
            @close="showPopup = false"
            @open-competitor="openCompetitor(...arguments)"
            class="popup autocasion-popup"
            :style="{ top: 160 + 'px', left:  590 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            ref="popup_Autocasion"
          />

          <ExplorationAutocasionPopup
            v-for="(compId, index) in Competitors"
            :key="`Autocasion_${compId}`"
            :isCompetitor="true"
            :competitorId="compId"
            @close="Competitors.splice(index, 1)"
            :style="{ top: calcTop(160, index) + 'px', left: calcLeft(590, index) + 'px', width: 800 + 'px', 'text-align': 'left' }"
            class="popup autocasion-popup"
          />
        </template>

        <!-- Marktplaats Popup  -->
        <template v-if="apiData.ApiName == 'Marktplaats'">
          <ExplorationMarktplaatsPopup
            v-if="showPopup"
            :marktplaatsData="apiData"
            :headLine="clientInfo.name"
            @close="showPopup = false"
            @open-competitor="openCompetitor(...arguments)"
            class="popup marktplaats-popup"
            :style="{ top: 190 + 'px', left:  620 + 'px', width: 800 + 'px', 'text-align': 'left' }"
            ref="popup_Marktplaats"
          />

          <ExplorationMarktplaatsPopup
            v-for="(compId, index) in Competitors"
            :key="`Marktplaats_${compId}`"
            :isCompetitor="true"
            :competitorId="compId"
            @close="Competitors.splice(index, 1)"
            :style="{ top: calcTop(190, index) + 'px', left: calcLeft(620, index) + 'px', width: 800 + 'px', 'text-align': 'left' }"
            class="popup marktplaats-popup"
          />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import CxDashboardContentMixin from "@/mixins/jlr/CxDashboardContentMixin.js";
import CxIconValueIndicator from './CxIconValueIndicator.vue';
import ExplorationGooglePopup from "@/components/CX/ExplorationGooglePopup";
import ExplorationMobilePopup from "@/components/CX/ExplorationMobilePopup";
import ExplorationAutoscoutPopup from "@/components/CX/ExplorationAutoscoutPopup";
import ExplorationSeobilityPopup from "@/components/CX/ExplorationSeobilityPopup";
import ExplorationAutocasionPopup from "@/components/CX/ExplorationAutocasionPopup";
import ExplorationMarktplaatsPopup from "@/components/CX/ExplorationMarktplaatsPopup";
import ExplorationSurveyPopup from "@/components/CX/ExplorationSurveyPopup";
import moment from "moment";

const NO_DATA_STRING = '<strong>No data</strong>';

export default {
  mixins: [ CxDashboardContentMixin ],
  
  components: { 
    CxIconValueIndicator, 
    ExplorationGooglePopup, 
    ExplorationMobilePopup, 
    ExplorationAutoscoutPopup, 
    ExplorationSeobilityPopup, 
    ExplorationAutocasionPopup, 
    ExplorationMarktplaatsPopup,
    ExplorationSurveyPopup
  },

  props: {
    afsData:            { type: Object, default: () => undefined },
    api:                { type: Object, default: () => undefined },
    apiData:            { type: Object, default: () => undefined },
    nonAfsData:         { type: Object, default: () => undefined },
    threshold:          { type: Array, required: true },
    dealerData:         { type: Object, default: () => undefined},
    clientInfo:         { type: Object, default: () => undefined},
  },

  data() {
    return {
      showPopup: false,
      Competitors: [],
    }
  },

  methods: {
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
    
    openCompetitor(competitorId) {
      if (_.indexOf(this.Competitors, competitorId) < 0) {
        this.Competitors.push(competitorId);
      } else {
        _.remove(this.Competitors, function(c) {
          return c === competitorId;
        });
        this.$forceUpdate();
      }
    },

    getLogoUrl(logoUrl) {
      if (logoUrl) {
        let staticUrlPart = logoUrl.includes('static') ? '' : 'static/';
        return `${process.env.BASE_URL}${staticUrlPart}${logoUrl}`;
      } else if (this.api.ExtLogoId) {
        return `${process.env.BASE_URL}api/media/image?id=${this.api.ExtLogoId}`;
      } else {
        return null
      }
    },

    getCustomPropValue(customPropName) {
      return this.dealerData?.CustomProperties?.find(p => p.PropertyName.toLowerCase() == customPropName)?.PropertyValue;
    },

    isAccomplished(index) {
      if (this.isApi(this.api)) {
        try {
          return this.apiData.OverallScores[index].IsAccomplished;
        } catch (error) {
          return undefined;
        }
      }
      if (this.isExploration(this.api))
        return this.apiData.IsAccomplished;

      if (this.isNonExploration(this.api))
        return this.api.LastCheckResult[0].IsAccomplished;

      return undefined;
    },

    getLineHeaderTooltip() {
      if (this.isApi(this.api)) {
        return `<strong>${this.api.apiName}</strong>`;
      } else if(this.isNonExploration(this.api) || this.isExploration(this.api)) {
        return `<strong>${this.api.SurveyTitle}</strong><br/>SID: ${this.api.ExternalSurveyId}`;
      }
    },

    getTooltip(no, index) {
      if (this.isApi(this.api)) {
        let items = this.apiData.OverallScores;
        try {
          if (!items[no] || items[no].Value === undefined) return NO_DATA_STRING;
        } catch(error) {
          return NO_DATA_STRING;
        }
        if (items[no].MaxRating === 100){
          return `<strong>${moment(items[no].Date).format('MMM yyyy')}<br/>${items[no].Value}%`;
        }
        return `<strong>${moment(items[no].Date).format('MMM yyyy')}</strong><br/>${items[no].Value} ${this.$t('Webportal.RangeOf')} ${items[no].MaxRating}`;
      } else if(this.isNonExploration(this.api)) {
        var items = [this.apiData.LastCheckResult[0], ...this.apiData.WaveResults, {}, {}, {}].slice(0,4);
        if (!items[no] || items[no].Result === undefined) return NO_DATA_STRING;
        return `<strong>Wave: ${items[no].WaveName}</strong><br/>${items[no].Result}%`;
      } else if(this.isExploration(this.api)) {
        var items = [this.apiData.LastCheckResult[0], ...this.api.WaveResults, {}, {}, {}].slice(0,4);
        if (!items[no] || items[no].Result === undefined) return NO_DATA_STRING;
        return `<strong>Wave: ${items[no].WaveName}</strong><br/>${items[no].Result}%`;
      } else {
        return NO_DATA_STRING;
      }
    },

    getValueText(index) {
      if (this.isApi(this.api)) {
        try {
          if (this.api.apiMaxRating === 100)
            return `${this.apiData.OverallScores[index].Value}%`;
          else
            return `${this.apiData.OverallScores[index].Value}`;
        } catch (error) {
          return 'N/A';
        }
      } else if(this.isNonExploration(this.api)) {
        let items = [this.apiData.LastCheckResult[0],
          ...this.apiData.WaveResults, {}, {}, {}].slice(0,4);
        let item = items[index];
        if (!item || item.Result === undefined) return '-';
        return `${item.Result}%`;
      } else if(this.isExploration(this.api)) {
        let items = [this.apiData.LastCheckResult[0], ...this.api.WaveResults, {}, {}, {}].slice(0,4);
        let item = items[index];
        if (!item || item.Result === undefined) return '-';
        return `${item.Result}%`;
      } else {
        return '-';
      }
    },

    getTitle() {
      if (this.isApi(this.api) || this.isExploration(this.api)) {
        return this.apiData.SurveyTitle;
      }
      return this.apiData.ScenarioName;
    },

    getValue(index) {
      if(this.isApi(this.api)) {
        if (this.apiData && this.apiData.OverallScores) 
          return this.apiData.OverallScores[index].Value;
      }
      else if(this.isNonExploration(this.api)) {
        let items = [this.apiData.LastCheckResult[0], ...this.apiData.WaveResults, {}, {}, {}].slice(0,4);
        return items[index]?.Result;
      } else if(this.isExploration(this.api)) {
        let items = [this.apiData.LastCheckResult[0], ...this.apiData.WaveResults, {}, {}, {}].slice(0,4);
        return items[index]?.Result;
      }
      return null;
    },
    
    calcTop(pos, index) {
      return Math.min(pos + ((index || 0) + 1) * 30, window.innerHeight - 500);
    },
    
    calcLeft(pos, index) {
      return Math.min(pos + ((index || 0) + 1) * 200, window.innerWidth - 500);
    },
  }
}
</script>

<style lang="scss" scoped>

.local-item {
  border-top: 1px solid var(--color-primary);
}

.local-last-value {
  border-left: 1px solid var(--color-primary);
}

.local-text {
  font-weight: 600;
  text-align: center;
}
.local-text-place {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.local-image-place {
  margin-top: 0.5rem;
}
.local-end {
  text-align: right;
}

.local-end .b-icon {
  margin-inline: 0.25rem;
}

.local-image {
  max-width: 110px; 
  max-height: 35px;
}
</style>